import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { MODULOS } from '../utils/permissoes';

const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const th = { padding: '10px 12px', background: '#F5F7FA', color: '#9AA3AE', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '12px 12px', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };

const nivelBadge = (n) => ({
  display: 'inline-block', padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600',
  background: n === 'admin' ? '#FFF3E0' : n === 'gerente' ? '#E6F1FB' : n === 'visualizacao' ? '#F1ECFB' : '#EAF5EE',
  color: n === 'admin' ? '#B06000' : n === 'gerente' ? '#185FA5' : n === 'visualizacao' ? '#6B3FA0' : '#2D7D4F'
});

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalSenha, setModalSenha] = useState(null);
  const [form, setForm] = useState({});
  const [canais, setCanais] = useState([]);
  const [modalCanal, setModalCanal] = useState(null);
  const [novaSenha, setNovaSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [msgSenha, setMsgSenha] = useState(null);
  const { usuario } = useAuth();

  useEffect(() => { carregar(); carregarCanais(); }, []);

  const carregarCanais = () => api.get('/vendas/canais?all=true').then(r => setCanais(r.data)).catch(() => setCanais([]));

  const carregar = () => api.get('/usuarios').then(r => setUsuarios(r.data));

  const salvar = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { modulos, ...dados } = form;
      let id = form.id;
      if (id) await api.put('/usuarios/' + id, dados);
      else {
        id = (await api.post('/usuarios', dados)).data.id;
        setForm(f => ({ ...f, id })); // se as permissões falharem, o próximo Salvar edita em vez de duplicar
      }
      // Visualização: módulos que pode ver, salvos junto com o usuário.
      if (form.nivel === 'visualizacao') await api.put('/usuarios/permissoes/' + id, { modulos: modulos || [] });
      setModal(false); setForm({}); carregar();
    } catch (err) { alert(err.response?.data?.error || 'Erro'); }
    finally { setLoading(false); }
  };

  const abrirEdicao = async (u) => {
    let modulos = [];
    if (u.nivel === 'visualizacao') {
      try { modulos = (await api.get('/usuarios/permissoes/' + u.id)).data.filter(p => p.pode_ver).map(p => p.modulo); }
      catch (err) { alert('Não foi possível carregar as permissões: ' + (err.response?.data?.error || err.message)); return; }
    }
    setForm({ ...u, modulos }); setModal(true);
  };

  const toggleModulo = (m) => setForm(f => {
    const atual = f.modulos || [];
    return { ...f, modulos: atual.includes(m) ? atual.filter(x => x !== m) : [...atual, m] };
  });

  const redefinirSenha = async () => {
    setMsgSenha(null);
    if (!novaSenha || novaSenha.length < 6) { setMsgSenha({ tipo: 'erro', texto: 'Senha deve ter pelo menos 6 caracteres' }); return; }
    setLoading(true);
    try {
      await api.put('/usuarios/' + modalSenha.id + '/senha', { nova_senha: novaSenha });
      setMsgSenha({ tipo: 'ok', texto: 'Senha redefinida com sucesso!' });
      setNovaSenha('');
    } catch (err) { setMsgSenha({ tipo: 'erro', texto: err.response?.data?.error || 'Erro' }); }
    finally { setLoading(false); }
  };

  const inp = (label, campo, tipo = 'text', opts) => (
    <div style={{ marginBottom: '12px' }}>
      <label style={lbl}>{label}</label>
      {opts ? (
        <select value={form[campo] || ''} onChange={e => setForm({ ...form, [campo]: e.target.value })} style={inpStyle}>
          {opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
        </select>
      ) : (
        <input type={tipo} value={form[campo] || ''} onChange={e => setForm({ ...form, [campo]: e.target.value })} style={inpStyle} />
      )}
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>
          Usuários <span style={{ fontSize: '14px', color: '#6B7A8D', fontWeight: '400' }}>({usuarios.length})</span>
        </div>
        <button onClick={() => { setForm({ nivel: 'vendedor', role: 'vendedor', ativo: true }); setModal(true); }}
          style={{ padding: '9px 18px', background: '#1A6DFF', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
          + Novo Usuário
        </button>
      </div>

      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '16px 18px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Nome', 'Email', 'Nível', 'Status', ''].map(h => <th key={h} style={th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id}>
                <td style={{ ...td, fontWeight: '500' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: '#1A3A5C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', color: '#fff', flexShrink: 0 }}>
                      {u.nome?.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()}
                    </div>
                    {u.nome}
                    {u.id === usuario?.id && <span style={{ fontSize: '10px', color: '#185FA5', fontWeight: '600' }}>(você)</span>}
                  </div>
                </td>
                <td style={{ ...td, color: '#6B7A8D', fontSize: '12px' }}>{u.email}</td>
                <td style={td}><span style={nivelBadge(u.role || u.nivel)}>{u.role || u.nivel}</span></td>
                <td style={td}>
                  <span style={{ fontSize: '11px', fontWeight: '600', color: u.ativo ? '#2D7D4F' : '#C0392B' }}>
                    {u.ativo ? '● Ativo' : '● Inativo'}
                  </span>
                </td>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => abrirEdicao(u)}
                      style={{ padding: '4px 10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#1A3A5C', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                      Editar
                    </button>
                    <button onClick={() => { setModalSenha(u); setNovaSenha(''); setMsgSenha(null); }}
                      style={{ padding: '4px 10px', background: 'transparent', border: '1px solid #B06000', color: '#B06000', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>
                      🔒 Senha
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Novo/Editar Usuário */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px', width: '460px', maxHeight: '88vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>{form.id ? 'Editar' : 'Novo'} Usuário</h3>
              <button onClick={() => { setModal(false); setForm({}); }} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <form onSubmit={salvar}>
              {inp('Nome completo', 'nome')}
              {inp('Email', 'email', 'email')}
              {!form.id && inp('Senha inicial', 'senha', 'password')}
              {inp('Nível de acesso', 'nivel', 'text', [
                { v: 'vendedor', l: 'Vendedor' },
                { v: 'gerente', l: 'Gerente' },
                { v: 'admin', l: 'Administrador' },
                { v: 'visualizacao', l: 'Visualização (só leitura)' },
              ])}
              {form.nivel === 'visualizacao' && (
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Módulos que pode ver</label>
                  <div style={{ fontSize: '12px', color: '#6B7A8D', marginBottom: '8px' }}>Só vê — não cria, não edita, não exclui.</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 16px', padding: '10px 12px', background: '#F4F6F9', borderRadius: '8px' }}>
                    {MODULOS.filter(m => m.modulo !== 'consorcio' || usuario?.empresa_id === 12).map(m => ( // Consórcio: só Autop
                      <label key={m.modulo} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#1C2533', cursor: 'pointer' }}>
                        <input type='checkbox' checked={(form.modulos || []).includes(m.modulo)} onChange={() => toggleModulo(m.modulo)} style={{ accentColor: '#1A6DFF' }} />
                        {m.label}
                      </label>
                    ))}
                  </div>
                </div>
              )}
              {form.id && (
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Status</label>
                  <select value={form.ativo ? 'true' : 'false'} onChange={e => setForm({ ...form, ativo: e.target.value === 'true' })} style={inpStyle}>
                    <option value='true'>Ativo</option>
                    <option value='false'>Inativo</option>
                  </select>
                </div>
              )}
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <button type='button' onClick={() => { setModal(false); setForm({}); }}
                  style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                  Cancelar
                </button>
                <button type='submit' disabled={loading}
                  style={{ flex: 1, padding: '10px', background: '#1A6DFF', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                  {loading ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Redefinir Senha */}
      {modalSenha && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px', width: '400px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>🔒 Redefinir senha</h3>
              <button onClick={() => setModalSenha(null)} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '20px' }}>Usuário: <strong>{modalSenha.nome}</strong></div>

            {msgSenha && (
              <div style={{ padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', background: msgSenha.tipo === 'ok' ? '#EAF5EE' : '#FDECEA', color: msgSenha.tipo === 'ok' ? '#2D7D4F' : '#C0392B', fontSize: '13px', fontWeight: '500' }}>
                {msgSenha.texto}
              </div>
            )}

            <div style={{ marginBottom: '16px' }}>
              <label style={lbl}>Nova senha</label>
              <input type='password' value={novaSenha} onChange={e => setNovaSenha(e.target.value)}
                placeholder='Mínimo 6 caracteres' style={inpStyle} />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalSenha(null)}
                style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Cancelar
              </button>
              <button onClick={redefinirSenha} disabled={loading}
                style={{ flex: 1, padding: '10px', background: '#B06000', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                {loading ? 'Salvando...' : 'Redefinir'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Gerenciamento de Canais ── */}
      <div style={{ marginTop: '32px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>Canais de Venda</div>
          <button onClick={() => setModalCanal({ nome: '' })}
            style={{ padding: '8px 16px', background: '#1A6DFF', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
            + Novo Canal
          </button>
        </div>
        <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '16px 18px' }}>
          {canais.length === 0 ? (
            <div style={{ color: '#9AA3AE', fontSize: '13px', textAlign: 'center', padding: '20px' }}>Nenhum canal cadastrado</div>
          ) : canais.map(c => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '13px', color: c.ativo ? '#1C2533' : '#9AA3AE', textDecoration: c.ativo ? 'none' : 'line-through' }}>{c.nome}</span>
                {!c.ativo && <span style={{ fontSize: '11px', color: '#9AA3AE', background: '#F4F6F9', padding: '2px 8px', borderRadius: '20px' }}>Inativo</span>}
              </div>
              <div style={{ display: 'flex', gap: '6px' }}>
                <button onClick={() => setModalCanal(c)}
                  style={{ padding: '5px 12px', background: '#F4F6F9', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#1A3A5C', fontWeight: '600' }}>
                  Editar
                </button>
                <button onClick={() => api.put(`/vendas/canais/${c.id}`, { ativo: !c.ativo }).then(() => carregarCanais())}
                  style={{ padding: '5px 12px', background: c.ativo ? '#FFF3E0' : '#EAF5EE', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: c.ativo ? '#B06000' : '#2D7D4F', fontWeight: '600' }}>
                  {c.ativo ? 'Desativar' : 'Ativar'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Canal */}
      {modalCanal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px', width: '400px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>{modalCanal.id ? 'Editar' : 'Novo'} Canal</h3>
              <button onClick={() => setModalCanal(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#9AA3AE' }}>×</button>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label style={lbl}>Nome do Canal</label>
              <input value={modalCanal.nome || ''} onChange={e => setModalCanal(m => ({ ...m, nome: e.target.value }))}
                style={inpStyle} placeholder="Ex: TikTok, Google, Feirão..." />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalCanal(null)}
                style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Cancelar
              </button>
              <button onClick={async () => {
                if (!modalCanal.nome?.trim()) return;
                if (modalCanal.id) {
                  await api.post('/vendas/canais/update', { id: modalCanal.id, nome: modalCanal.nome });
                } else {
                  await api.post('/vendas/canais', { nome: modalCanal.nome });
                }
                setModalCanal(null);
                carregarCanais();
              }} style={{ flex: 1, padding: '10px', background: '#1A6DFF', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
